'use client';

// Import renderer, note that introducing the CanvasRenderer or SVGRenderer is a required step
import { Box } from '@mui/material';
// import the core library.
import ReactEChartsCore from 'echarts-for-react/lib/core';
// Import charts, all with Chart suffix
import { ScatterChart } from 'echarts/charts';
// import components, all suffixed with Component
import {
  DatasetComponent,
  GridComponent,
  TooltipComponent,
  VisualMapComponent,
} from 'echarts/components';
// Import the echarts core module, which provides the necessary interfaces for using echarts.
import * as echarts from 'echarts/core';
import {
  //   CanvasRenderer,
  SVGRenderer,
} from 'echarts/renderers';
import Image from 'next/image';
import { type FC, useMemo } from 'react';

type Props = {
  img?: any;
  positions: [radiusAxis: number, angleAxis: number][];
  color?: string;
};

// Register the required components
echarts.use([
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  VisualMapComponent,
  ScatterChart,
  SVGRenderer,
]);

export const PositionInWheelScatter: FC<Props> = (props: Props) => {
  const { positions, img } = props;

  const option = useMemo(
    () => ({
      grid: {
        top: 16,
        bottom: 16,
      },
      tooltip: {
        show: false,
      },
      polar: {},
      radiusAxis: {
        min: 0,
        max: 100,
        interval: 20,
        splitLine: {
          show: !img,
          lineStyle: {
            color: ['#fff'],
            width: 2,
          },
        },
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
      },
      angleAxis: {
        min: 0,
        max: 360,
        interval: 45,
        // TODO: A vérifier avec Samo
        startAngle: 45,
        clockwise: false,
        splitLine: {
          show: !img,
          lineStyle: {
            color: ['#fff'],
            width: 2,
          },
        },
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
      },
      series: {
        type: 'scatter',
        coordinateSystem: 'polar',
        data: positions,
        // Can be an image
        symbol: 'circle',
        symbolSize: 40,
        itemStyle: {
          color: '#00CED1',
          opacity: 1,
        },
      },
    }),
    [positions, img]
  );

  return (
    <Box
      component="div"
      position="relative"
      width={{ none: '320px', sx: '480px', md: '640px' }}
      height={{ none: '320px', sx: '480px', md: '640px' }}
    >
      {img && (
        <Box
          component="div"
          position="absolute"
          top="50%"
          left="50%"
          width={{ none: '300px', sx: '450px', md: '600px' }}
          height={{ none: '300px', sx: '450px', md: '600px' }}
          sx={{ transform: 'translate(-50%, -50%)' }}
        >
          <Image
            src={img}
            alt=""
            style={{ objectFit: 'contain', objectPosition: 'center' }}
            fill
          />
        </Box>
      )}
      <ReactEChartsCore
        echarts={echarts}
        option={option}
        notMerge={true}
        lazyUpdate={true}
        theme={'theme_name'}
        style={{ height: '100%', width: '100%', position: 'relative' }}
        opts={{}}
      />
    </Box>
  );
};
